import h5Layout from '@/views/h5/index.vue'
export const h5Routes = [
    {
        path: "/h5",
        name: "h5",
        component: h5Layout,
        children: [
            {
                path: "/h5/newsDetail",
                name: "h5-newsDetail",
                component: () => import("@/views/h5/topic/news/detail.vue"),
                meta: {
                    documentTitle: "资讯详情",
                },
            },
                 {
                //订单退费申请
                path: "/h5/refundOrderDetail",
                name: "h5-refundOrderDetail",
                component: () =>
                    import("@/views/h5/topic/myOrder/refundOrderDetail.vue"),
            },
            {
                //订单退费申请
                path: "/h5/refundOrderNext",
                name: "h5-refundOrderNext",
                component: () =>
                    import("@/views/h5/topic/myOrder/refundOrderNext.vue"),
            },

            {
                //订单退费申请
                path: "/h5/refundList",
                name: "h5-refundList",
                component: () =>
                    import("@/views/h5/topic/myOrder/refundList.vue"),
            },
            {
                //订单退费申请
                path: "/h5/refundOrder",
                name: "h5-refundOrder",
                component: () =>
                    import("@/views/h5/topic/myOrder/refundOrder.vue"),

                meta: {
                    keepCase: ["h5-refundOrderNext"],
                },

            },
            {
                //付款记录
                path: "/h5/payRecord",
                name: "h5-payRecord",
                component: () =>
                    import("@/views/h5/topic/myOrder/payRecord.vue"),
            },
            {
                //缴费单
                path: "/h5/payBill",
                name: "h5-payBill",
                component: () => import("@/views/h5/topic/myOrder/payBill.vue"),
            },
            {
                // hrm线上面试说明
                path: "/h5/ruleOnlineInterviewInstruct",
                name: "h5-ruleOnlineInterviewInstruct",
                component: () => import("@/views/h5/onlineInterview/ruleInstruct.vue"),
            },
            {
                // 常规考试
                path: "/h5/regularExam",
                name: "h5-regularExam",
                component: () =>
                    import("@/views/h5/topic/regularExam/index.vue"),
                   meta: {
                    keepCase: ["h5-videoAnalysis"],
                },
            },
            {
                //考试结果
                path: "/h5/result",
                name: "h5-result",
                component: () =>
                    import("@/views/h5/topic/regularExam/result.vue"),
            },

            {
                path: "/h5/analysis",
                name: "h5-analysis",
                component: () =>
                    import("@/views/h5/topic/regularExam/analysis.vue"),
                   meta: {
                    keepCase: ["h5-videoAnalysis"],
                },
            },
          {
            // 订正错题--单题消灭
            path: "/h5/errExerciseExam",
            name: "h5-errExerciseExam",
            component: () =>
              import("@/views/h5/topic/regularExam/errExerciseExam.vue"),
            meta: {
              keepCase: ["h5-videoAnalysis"],
              documentTitle: "错题练习",
            },
          },
            {
                path: "/h5/knowledgeExplain",
                name: "h5-knowledgeExplain",
                component: () =>
                    import("@/views/h5/topic/regularExam/knowledgeExplain.vue"),
                 meta: {
                    documentTitle: "知识点精讲",
                    keepCase: ["h5-regularExam"],
                },
            },
             {
                path: "/h5/VideoAnalysis",
                name: "h5-videoAnalysis",
                component: () =>
                    import("@/views/h5/topic/regularExam/VideoAnalysis.vue"),
            },
            {
                path: "/h5/login",
                name: "h5Login",
                component: () => import("@/views/h5/login/index.vue"),
                meta: {
                    documentTitle: "登录",
                },
            },
            {
                path: "/h5/loginSuccess",
                name: "h5LoginSuccess",
                component: () => import("@/views/h5/login/loginSuccess.vue"),
                meta: {
                    documentTitle: "登录成功",
                },
            },
            {
                path: "/h5/my",
                name: "my",
                component: () => import("@/views/h5/my/index.vue"),
                meta: {
                    documentTitle: "个人中心",
                },
            },
            {
                // 作业--相同组件复用
                path: "/h5/myHomework",
                name: "h5MyHomework",
                component: () => import("@/views/h5/topic/list/index.vue"),
                meta: {
                    documentTitle: "作业",
                },
            },
            {
                // 考试--相同组件复用
                path: "/h5/myExam",
                name: "h5MyExam",
                component: () => import("@/views/h5/topic/list/index.vue"),
                meta: {
                    documentTitle: "考试",
                },
            },
            {
                // 自主练习--相同组件复用
                path: "/h5/myExercise",
                name: "h5MyExercise",
                component: () => import("@/views/h5/topic/list/index.vue"),
                meta: {
                    documentTitle: "自主练习",
                },
            },
            {
                // 作业--详情列表类型1(三个作业、课后测等)
                path: "/h5/workExamList",
                name: "h5WorkExamList",
                component: () =>
                    import("@/views/h5/topic/list/workExamList/index.vue"),
                meta: {
                    documentTitle: "",
                    keepCase: ["h5WorkExamRecord"],
                },
            },
            {
                // 作业--详情列表类型1(三个作业、课后测等)----考试记录查看页
                path: "/h5/workExamRecord",
                name: "h5WorkExamRecord",
                component: () =>
                    import("@/views/h5/topic/list/workExamList/record.vue"),
                meta: {
                    documentTitle: "考试记录",
                },
            },
            {
                // 作业--详情列表类型2(章节练习)
                path: "/h5/chapExercise",
                name: "h5ChapExercise",
                component: () =>
                    import("@/views/h5/topic/list/chapExercise/index.vue"),
                meta: {
                    documentTitle: "章节练习",
                },
            },
            {
                // 作业--详情列表类型3(错题练习)
                path: "/h5/errExercise",
                name: "h5ErrExercise",
                component: () =>
                    import("@/views/h5/topic/list/errExercise/index.vue"),
                meta: {
                    documentTitle: "错题练习",
                    // keepCase: ["h5ErrExercise"],
                },
            },

            {
                // 作业--详情列表类型3(错题练习)
                path: "/h5/errExerciseList",
                name: "h5ErrExerciseList",
                component: () =>
                    import("@/views/h5/topic/list/errExercise/list.vue"),
                meta: {
                    documentTitle: "错题练习",
                },
            },

            {
                // 做题记录
                path: "/h5/examRecord",
                name: "examRecord",
                component: () =>
                    import("@/views/h5/topic/list/examRecord/index.vue"),
                meta: {
                    documentTitle: "做题记录",
                },
            },
            {
                path: "/h5/aiSession",
                name: "h5AiSession",
                component: () => import("@/views/h5/aiSession/aiAsk.vue"),
                meta: {
                    documentTitle: "财税答疑",
                    keepCase: ["h5-ask"],
                },
            },
            {
                // 推送卡片的，此页面需传入参数省和市
                path: "/h5/hireDetail",
                name: "h5HireDetail",
                component: () => import("@/views/h5/hire/detail.vue"),
                meta: {
                    documentTitle: "招聘详情",
                },
            },
            {
                // 推送卡片的，此页面需传入参数省和市
                path: "/h5/myHire",
                name: "h5MyHire",
                component: () => import("@/views/h5/hire/my.vue"),
                meta: {
                    documentTitle: "招聘信息",
                },
            },
            {
                // 推送卡片的，此页面需传入参数省和市
                path: "/h5/myHire)",
                name: "h5MyHire)",
                component: () => import("@/views/h5/hire/my.vue"),
                meta: {
                    documentTitle: "招聘信息",
                },
            },
            {
                //我的订单
                path: "/h5/myOrder",
                name: "h5-myOrder",
                component: () => import("@/views/h5/topic/myOrder/index.vue"),
            },
            {
                //产品支付确认
                path: "/h5/payConfirm",
                name: "h5-payConfirm",
                component: () =>
                    import("@/views/h5/topic/myOrder/productPayConfirm.vue"),
            },
            {
                //订单支付确认
                path: "/h5/orderPayConfirm",
                name: "h5-orderPayConfirm",
                component: () =>
                    import("@/views/h5/topic/myOrder/orderPayConfirm.vue"),
            },
            {
                //复训支付确认
                path: "/h5/retrainPayConfirm",
                name: "h5-retrainPayConfirm",
                component: () =>
                    import("@/views/h5/topic/myOrder/retrainPayConfirm.vue"),
            },
            {
                //协议列表
                path: "/h5/protocol",
                name: "h5-protocol",
                component: () =>
                    import("@/views/h5/topic/myOrder/protocolList.vue"),
            },
            {
                // 隐私
                path: '/h5/policy',
                name: 'h5-policy',
                component: () => import('@/views/h5/topic/info/policy.vue')
            },
            {
                // 协议
                path: '/h5/agreement',
                name: 'h5-agreement',
                component: () => import('@/views/h5/topic/info/agreement.vue')
            },

            {
                // 推送卡片的，此页面需传入参数省和市
                path: "/h5/courseDetail",
                name: "courseDetail",
                component: () => import("@/views/h5/topic/course/detail.vue"),
                meta: {
                    documentTitle: "课程收益",
                },
            },
             {
                //课程列表
                path: "/h5/courseList",
                name: "courseList",
                component: () => import("@/views/h5/topic/course/list.vue"),
                meta: {
                    documentTitle: "课程列表",
                },
            },
            {
                path: "/h5/productDetail",
                name: "productDetail",
                component: () => import("@/views/h5/topic/course/productDetail.vue"),
                meta: {
                    documentTitle: "课程详情",
                },
            },
            {
                //实名认证
                path: "/h5/realNameAuth",
                name: "h5-realNameAuth",
                component: () =>
                    import("@/views/h5/topic/myOrder/realNameAuth.vue"),
            },
            {
                path: "/h5/pdfView",
                name: "h5-pdfView",
                component: () => import("@/views/h5/widget/pdfView.vue"),
                meta: {
                    title: "预览",
                    loginM: true,
                },
            },
            {
                path: "/h5/diploma",
                name: "h5-diploma",
                component: () => import("@/views/h5/topic/diploma/index.vue"),
            },
            {
                path: "/h5/diplomaDetail",
                name: "h5-diplomaDetail",
                component: () => import("@/views/h5/topic/diploma/detail.vue"),
            },
            {
                path: "/h5/diplomaReport",
                name: "h5-diplomaReport",
                component: () => import("@/views/h5/topic/diploma/report.vue"),
            },
            {
                path: "/h5/qa",
                name: "h5-qa",
                component: () => import("@/views/h5/topic/qa/index.vue"),
                meta: {
                    documentTitle: "",
                },

            },
            {
                path: "/h5/ask",
                name: "h5-ask",
                component: () => import("@/views/h5/topic/qa/ask.vue"),
                meta: {
                    documentTitle: "转交专家解答",
                },
            },
            {
                path: "/h5/myAsk",
                name: "h5-myAsk",
                component: () => import("@/views/h5/topic/qa/myAsk.vue"),
            },
            {
                path: "/h5/askDetail",
                name: "h5-askDetail",
                component: () => import("@/views/h5/topic/qa/detail.vue"),
            },
            {
               // 产品售卖--点播试听
               path: "/h5/ptl",
               name: "h5Ptl",
               component: () => import("@/views/h5/productTrial/index.vue"),
               meta: {
                 documentTitle: "试听课程",
               },
            },
            {

                path: "/h5/mockInterviewReport",
                name: "h5-MockInterviewReport",
                component: () => import("@/views/h5/mockInterview/index.vue"),
                meta: {
                    documentTitle: "模拟面试报告",
                },
            },
            {

                path: "/h5/mockInterviewAppReport",
                name: "h5-MockInterviewAppReport",
                component: () => import("@/views/h5/mockInterview/appReport.vue"),
                meta: {
                    documentTitle: "模拟面试报告",
                },
            },
            {
                path: "/h5/jobService",
                name: "h5-jobService",
                component: () => import("@/views/h5/topic/jobService/index.vue"),
                meta: {
                    documentTitle: "",
                    keepCase: ["h5-applyHistory", 'h5-pdfView'],
                },
            },
            {
                path: "/h5/applyHistory",
                name: "h5-applyHistory",
                component: () => import("@/views/h5/topic/jobService/applyHistory.vue"),
            },
            {
                path: "/h5/applyDetail",
                name: "h5-applyDetail",
                component: () => import("@/views/h5/topic/jobService/applyDetail.vue"),
            },
             {
                path: "/h5/zhuzhu-play",
                name: "h5-zhuzhuPlay",
                component: () => import("@/views/h5/zhuzhu-play/index.vue"),
            },
           {
             path: "/h5/ptViQa",    // 就业大屏岗位--能力标签看视频、做题
             name: "h5PtViQa",
             component: () => import("@/views/h5/abilityVideoQa/index.vue"),
             meta: {
               documentTitle: "能力点巩固学习",
             },
           },
           {
             path: "/h5/stuStory",
             name: "h5StuStory",
             component: () => import("@/views/h5/topic/stuStory/index.vue"),
               meta: {
               documentTitle: "优秀学员案例",
             },
           },
           {
             path: "/h5/stuStoryDetail",
             name: "h5StuStoryDetail",
             component: () => import("@/views/h5/topic/stuStory/detail.vue"),
               meta: {
               documentTitle: "优秀学员案例",
             },
           },
           {
             path: "/h5/messageBoard",
             name: "h5messageBoard",
             component: () => import("@/views/h5/topic/messageBoard/index.vue"),
               meta: {
               documentTitle: "留言板",
             },
           },
           {
             path: "/h5/mockInterview",
             name: "h5MockInterview",
             component: () => import("@/views/h5/mockInterview/interview.vue"),
               meta: {
               documentTitle: "能力测评",
             },
           },
           {
             path: "/h5/mockInterviewJob",
             name: "h5MockInterviewJob",
             component: () => import("@/views/h5/mockInterview/interviewJob.vue"),
               meta: {
               documentTitle: "模拟面试",
             },
           },
           {
             path: "/h5/mockInterviewTip",
             name: "h5MockInterviewTip",
             component: () => import("@/views/h5/mockInterview/tip.vue"),
               meta: {
               documentTitle: "提示",
             },
           },
            {
             path: "/h5/message",
             name: "h5-message",
             component: () => import("@/views/h5/topic/message/index.vue"),
               meta: {
               documentTitle: "消息通知",
               keepCase: ['h5-messageBoardDetail'],
             },
           },
           {
             path: "/h5/messageBoardDetail",
             name: "h5-messageBoardDetail",
             component: () => import("@/views/h5/topic/message/messageBoardDetail.vue"),
               meta: {
               documentTitle: "留言板详情",
             },
           },
           {
             path: "/h5/qwTools/index",
             name: "qwToolsIndex",
             component: () => import("@/views/h5/qwTools/index.vue"),
             meta: {
               documentTitle: "",
             },
           },
           {
             // 滑块验证码（供 App 弹窗嵌入）
             path: "/h5/captcha",
             name: "h5Captcha",
             component: () => import("@/views/h5/captcha/index.vue"),
             meta: {
               documentTitle: "安全验证",
             },
           },
            {
             path: "/h5/AppUserGuide",
             name: "h5-AppUserGuide",
             component: () => import("@/views/h5/topic/appGuide/AppUserGuide.vue"),
               meta: {
               documentTitle: "仁和会计课堂 APP 使用手册（学员版）",
             },
           },
        ]
    }
]
